import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/images/logo/iknowa-logo-v4.svg'
import _imports_1 from '../../../../assets/icons/yellow-pound.png'


const _withScopeId = n => (_pushScopeId("data-v-445c6d24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: 160,
  "aspect-ratio": "16/9",
  cover: "",
  src: _imports_0,
  class: "logo_top"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "main_p" }, " Select your workstation type, you can change at any time. ", -1))
const _hoisted_4 = { class: "modal_card_list top_list" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Access Property Insights ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Raise Projects ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Collaborate With Others ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-logo-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "custom__tags" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "onbording-wrap__card-tag" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "tag-item__points" }, [
        /*#__PURE__*/_createElementVNode("span", null, "FREE"),
        /*#__PURE__*/_createTextVNode(" Forever ")
      ])
    ])
  ])
], -1))
const _hoisted_9 = { class: "card_body" }
const _hoisted_10 = { class: "card_main" }
const _hoisted_11 = { class: "card_right" }
const _hoisted_12 = { class: "modal_card_list" }
const _hoisted_13 = { class: "onbording-wrap__card-details__text" }
const _hoisted_14 = { class: "card_left" }
const _hoisted_15 = { class: "onbording-wrap__card-details" }
const _hoisted_16 = { class: "onbording-wrap__card-details__icon" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Occupiers / Renters", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Property overview "),
  /*#__PURE__*/_createElementVNode("text", null, "(inc. energy efficiency)")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Record or raise projects to be approved ", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Invite your landlord or property manager ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Store & manage key documents (100MB) ", -1))
const _hoisted_22 = { class: "card_footer" }
const _hoisted_23 = { class: "cardfooter_right" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-logo-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "custom__tags" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "onbording-wrap__card-tag" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "tag-item__points" }, [
        /*#__PURE__*/_createElementVNode("span", null, "FREE"),
        /*#__PURE__*/_createTextVNode(" Basic Workstation ")
      ])
    ])
  ])
], -1))
const _hoisted_26 = { class: "card_body" }
const _hoisted_27 = { class: "card_main" }
const _hoisted_28 = { class: "card_right" }
const _hoisted_29 = { class: "modal_card_list" }
const _hoisted_30 = { class: "onbording-wrap__card-details__text" }
const _hoisted_31 = { class: "card_left" }
const _hoisted_32 = { class: "onbording-wrap__card-details" }
const _hoisted_33 = { class: "onbording-wrap__card-details__icon" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Homeowners", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Property overview "),
  /*#__PURE__*/_createElementVNode("text", null, " (inc. energy efficiency)")
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Record or raise projects to be approved ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Invite your landlord or property manager ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Store & manage key documents (100MB) ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode(" From £6.39* p/month, for a verified workstation "),
    /*#__PURE__*/_createElementVNode("text", null, " (option to add 3 properties & includes 100GB storage)")
  ])
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", null, " From £6.39* per additional team member ")
], -1))
const _hoisted_41 = { class: "card_footer" }
const _hoisted_42 = { class: "cardfooter_right" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-logo-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "custom__tags" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "onbording-wrap__card-tag" }, [
      /*#__PURE__*/_createElementVNode("label", { class: "tag-item__points" }, [
        /*#__PURE__*/_createElementVNode("span", null, "FROM"),
        /*#__PURE__*/_createTextVNode(" £9.99 Per Month ")
      ])
    ])
  ])
], -1))
const _hoisted_45 = { class: "card_body" }
const _hoisted_46 = { class: "card_main" }
const _hoisted_47 = { class: "card_right" }
const _hoisted_48 = { class: "modal_card_list" }
const _hoisted_49 = { class: "onbording-wrap__card-details__text" }
const _hoisted_50 = { class: "card_left" }
const _hoisted_51 = { class: "onbording-wrap__card-details" }
const _hoisted_52 = { class: "onbording-wrap__card-details__icon" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Landlords, Developers & Businesses", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Everything in Basic & Standard, plus: ", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Store and manage unlimited documents ", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Add & manage unlimited properties ", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Includes API access* ", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Unlimited Title Lookups* ", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", null, " £9.99 per additional team member ")
], -1))
const _hoisted_60 = { class: "card_footer" }
const _hoisted_61 = { class: "cardfooter_right" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_OccupiersWorkstationComponent = _resolveComponent("OccupiersWorkstationComponent")!
  const _component_HomeownerWorkStationComponent = _resolveComponent("HomeownerWorkStationComponent")!
  const _component_LandlordsWorkStationComponent = _resolveComponent("LandlordsWorkStationComponent")!
  const _component_HomeownerWelcomeComponent = _resolveComponent("HomeownerWelcomeComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            md: "12",
            class: "top_content"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  "aria-label": "Refresh",
                  class: "back_btn",
                  "prepend-icon": "mdi-chevron-left",
                  onClick: $setup.onClickBackButton
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("back")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _hoisted_2,
              _createElementVNode("h1", null, "Create your workstation, " + _toDisplayString($setup.user?.firstName) + " 🚀", 1),
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                    _hoisted_5
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                    _hoisted_6
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                    _hoisted_7
                  ])
                ])
              ]),
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { lg: "4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "custom-card" }, {
                        default: _withCtx(() => [
                          _hoisted_8,
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                      _createElementVNode("div", _hoisted_15, [
                                        _createElementVNode("div", _hoisted_16, [
                                          _createVNode(_component_v_icon, { icon: "mdi-home-variant" })
                                        ])
                                      ])
                                    ]),
                                    _hoisted_17
                                  ]),
                                  _createElementVNode("ul", null, [
                                    _createElementVNode("li", null, [
                                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                                      _hoisted_18
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                                      _hoisted_19
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                                      _hoisted_20
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                                      _hoisted_21
                                    ])
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", _hoisted_23, [
                                _hoisted_24,
                                _createVNode(_component_v_btn, {
                                  class: "button button-purple-border purple_btn",
                                  size: "large",
                                  block: "",
                                  onClick: $setup.onClickOccupierscreation
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" cREATE workstation 🚀 ")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { lg: "4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "custom-card" }, {
                        default: _withCtx(() => [
                          _hoisted_25,
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                      _createElementVNode("div", _hoisted_32, [
                                        _createElementVNode("div", _hoisted_33, [
                                          _createVNode(_component_v_icon, { icon: "mdi-home-variant" })
                                        ])
                                      ])
                                    ]),
                                    _hoisted_34
                                  ]),
                                  _createElementVNode("ul", null, [
                                    _createElementVNode("li", null, [
                                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                                      _hoisted_35
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                                      _hoisted_36
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                                      _hoisted_37
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                                      _hoisted_38
                                    ]),
                                    _hoisted_39,
                                    _hoisted_40
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _hoisted_43,
                                _createVNode(_component_v_btn, {
                                  class: "button button-purple-border purple_btn",
                                  size: "large",
                                  block: "",
                                  onClick: $setup.onClickHomeownerscreation
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" cREATE workstation 🚀 ")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, { lg: "4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "custom-card" }, {
                        default: _withCtx(() => [
                          _hoisted_44,
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("div", _hoisted_46, [
                              _createElementVNode("div", _hoisted_47, [
                                _createElementVNode("div", _hoisted_48, [
                                  _createElementVNode("div", _hoisted_49, [
                                    _createElementVNode("div", _hoisted_50, [
                                      _createElementVNode("div", _hoisted_51, [
                                        _createElementVNode("div", _hoisted_52, [
                                          _createVNode(_component_v_icon, { icon: "mdi-home-variant" })
                                        ])
                                      ])
                                    ]),
                                    _hoisted_53
                                  ]),
                                  _createElementVNode("ul", null, [
                                    _createElementVNode("li", null, [
                                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                                      _hoisted_54
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                                      _hoisted_55
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                                      _hoisted_56
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                                      _hoisted_57
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createVNode(_component_v_icon, { icon: "mdi-check-circle" }),
                                      _hoisted_58
                                    ]),
                                    _hoisted_59
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              _createElementVNode("div", _hoisted_61, [
                                _hoisted_62,
                                _createVNode(_component_v_btn, {
                                  class: "button button-purple-border purple_btn",
                                  size: "large",
                                  block: "",
                                  onClick: $setup.onClickLandlordscreation
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" create workstation 🚀 ")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    ($setup.isShowOccupiersWorkStation)
      ? (_openBlock(), _createBlock(_component_OccupiersWorkstationComponent, {
          key: 0,
          onOnClickCloseTab: $setup.onClickCloseOccupiers
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true),
    ($setup.isShowHomeownersWorkStation)
      ? (_openBlock(), _createBlock(_component_HomeownerWorkStationComponent, {
          key: 1,
          onOnClickCloseTab: $setup.onClickCloseHomeowners
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true),
    ($setup.isShowLandlordsWorkStation)
      ? (_openBlock(), _createBlock(_component_LandlordsWorkStationComponent, {
          key: 2,
          onOnClickCloseTab: $setup.onClickCloseLandlords
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true),
    ($setup.isShowHomeownersWelcome)
      ? (_openBlock(), _createBlock(_component_HomeownerWelcomeComponent, {
          key: 3,
          onOnClickCloseTab: $setup.onClickCloseHomeownersWelcome
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true)
  ], 64))
}